// This file helps resolve initialization order issues with Pixi.js in production builds
// It ensures that the circular dependencies are resolved properly

// Pre-load Pixi.js to avoid initialization errors
export async function ensurePixiLoaded(): Promise<void> {
  try {
    // Dynamic import to ensure it's fully loaded before use
    await import("pixi.js");
    console.log("Pixi.js preloaded successfully");
  } catch (err) {
    console.error("Error preloading Pixi.js:", err);
    throw err;
  }
}
